module.exports = __webpack_public_path__ + "static/55-047c1720825c1a476a4decd404312aae.png";